let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aQp8v")).then(() => parcelRequire('eJPDm'));